
import gif from "../../images/glowgif01.gif";


import e from "../../images/e.png";
import ml from "../../images/ml.jpg";
import cyber from "../../images/cyber.jpg";



import train from "../../images/training01.png"
import training from "../../images/training.jpg";
import bgImage2 from "../../images/glow.png";
// import './Training.css';
import EastIcon from '@mui/icons-material/East';

import { useMediaQuery } from 'react-responsive'
import { useNavigate } from 'react-router-dom';

import 'swiper/css';
import 'swiper/css/pagination';
import React, { useEffect, useState, useRef } from 'react';

// import FileUploader from './FileUploader';


export const About = () => {
  const isMobileScreen = useMediaQuery({ query: '(max-width: 900px)' })
  const navigate = useNavigate();
  const handleJoinNowClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to the top of the page
    navigate('/contact'); // Navigate to the contact page
  };
  const [width, setWidth] = useState(window.innerWidth);
  const heroRef = useRef<HTMLDivElement | null>(null);
  const backgroundRef = useRef<HTMLDivElement | null>(null);



  useEffect(() => {
    const animateValue = (obj: HTMLElement, start: number, end: number, duration: number) => {
      let startTimestamp: number | null = null;
      const step = (timestamp: number) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        obj.innerHTML = Math.floor(progress * (end - start) + start).toString();
        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    };
  
    // Select all elements with a specific class
    const elements = document.querySelectorAll<HTMLElement>(".animate-value");
  
    if (elements.length === 0) {
      console.error("No elements with class 'animate-value' found in the DOM.");
      return;
    }
  
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const target = entry.target as HTMLElement;
            const endValue = parseInt(target.getAttribute("data-end") || "100", 10); // Use `data-end` for dynamic values
            animateValue(target, 0, endValue, 2000); // Start animation
            observer.unobserve(target); // Stop observing this element after animation starts
          }
        });
      },
      { threshold: 0.5 } // Trigger when 50% of the element is visible
    );
  
    // Observe each element
    elements.forEach((element) => observer.observe(element));
  
    return () => {
      observer.disconnect(); // Cleanup observer on component unmount
    };
  }, []);
  
  useEffect(() => {
    if (heroRef.current && backgroundRef.current) {
      heroRef.current.style.background = 'none';
      backgroundRef.current.style.backgroundImage = `url(${bgImage2})`;
    }
    const handleScroll = () => {
      if (backgroundRef.current) {
        const maxScroll = 630;
        const maxScaleTransform = 1.6;
        const maxScaleTop = 1.68;
        let scale = window.scrollY / 900 + 1;
        let scale1 = Math.max(1.6, scale);
        let scaleTop = window.scrollY / 910 + 1;
        let scaleside = window.scrollY / 910 + 1;
          console.log(window.scrollY );
      
        // if (window.scrollY > maxScroll) {
        //   backgroundRef.current.style.transform = `scale(1.6, 1.6)`;
        //   // backgroundRef.current.style.left = '-5%';
        //   scaleTop = 1.68;
          
        //   // backgroundRef.current.style.top = ``;

        // }
        if (window.scrollY > maxScroll) { 
          scale1= maxScaleTransform;
   
          scaleside = maxScaleTop ;
          scaleTop = maxScaleTop;
   

        }
        // if (window.scrollY > 750) { 
        //   scale1= maxScaleTransform;
   
        //   // scaleside = -(scaleside - 1) ;
        //   backgroundRef.current.style.left = `${(26.47 * scaleside) + 36.47}%`;
   

        // }
      

        backgroundRef.current.style.transform = `scale(${scale1 }, ${scale1 })`;
        // backgroundRef.current.style.transformOrigin = 'bottom right';
        backgroundRef.current.style.bottom = `-${(scaleTop - 1) *100}%`;
        // backgroundRef.current.style.left = `${(-26.47 * scaleside) + 30.47}%`;
      }
    };
    const handleScrollMobile = () => {
      if (backgroundRef.current) {
        const maxScroll = 630;
        const maxScaleTransform = 1.6;
        const maxScaleTop = 1.68;
        let scale = window.scrollY / 900 + 1;
        let scale1 = Math.max(1.6, scale);
        let scaleTop = window.scrollY / 910 + 1;
        let scaleside = window.scrollY / 910 + 1;
          console.log(window.scrollY );
      
        // if (window.scrollY > maxScroll) {
        //   backgroundRef.current.style.transform = `scale(1.6, 1.6)`;
        //   // backgroundRef.current.style.left = '-5%';
        //   scaleTop = 1.68;
          
        //   // backgroundRef.current.style.top = ``;

        // }
        if (window.scrollY > maxScroll) { 
          scale1= maxScaleTransform;
   
          scaleside = maxScaleTop ;
          scaleTop = 1.8;
   

        }
        // if (window.scrollY > 750) { 
        //   scale1= maxScaleTransform;
   
        //   // scaleside = -(scaleside - 1) ;
        //   backgroundRef.current.style.left = `${(26.47 * scaleside) + 36.47}%`;
   

        // }
      

        // backgroundRef.current.style.transform = `scale(${scale1 }, ${scale1 })`;
        // backgroundRef.current.style.txransformOrigin = 'bottom right';
        // backgroundRef.current.style.top = `${(-22.05 * scaleTop) + 47}%`;
        backgroundRef.current.style.bottom = `-${(scaleTop - 1) *100}%`;
        // backgroundRef.current.style.left = `${(-30.47 * scaleside) + 26.47}%`;
      }
    };
    const updateScrollHandler = () => {
      const isMobile = window.innerWidth <= 900; // Adjust breakpoint as needed
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', handleScrollMobile);
  
      if (isMobile) {
        window.addEventListener('scroll', handleScrollMobile);
      } else {
        window.addEventListener('scroll', handleScroll);
      }
    };
  
    // Set the initial scroll handler
    updateScrollHandler();
     // Update the scroll handler on resize
  window.addEventListener('resize', updateScrollHandler);
    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', handleScrollMobile);
      window.removeEventListener('resize', updateScrollHandler);
    };
}, []);

  
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div id="wrapper2_d">
    <section id='hero2_d' ref={heroRef} className="hero2_d"
    // style={{ backgroundImage: `url(${bgImage2})`, backgroundSize: 'auto', background: 'cover' }}
    >
         <div   className='glow_2'></div>

<div ref={backgroundRef} className="background">
<div   ref={backgroundRef}className='glow'></div>
</div>
<div className="background2"></div>
      {/* <div ref={backgroundRef} className="background">
      Staffing
      </div> */}
      <div className='hero__flex'  >
     
      <div className='hero__left'  >
      <div className='img_box'>
      <img src={training}  className='intro_img first'  />
      <img src={train}  className='intro_img'  />
      {/* <img src={staff}  className='intro_img'  />   */}
      <div className='intro_img'>
      <div style={{display:'flex',flexDirection:'row',justifyContent:'center',}}>
        {/* <div className="num animate-value"  data-end="4">0</div><a style={{fontSize:'30px',paddingLeft:'0px'}}>+</a> */}
        </div>
        <div className="text">Innovative</div>
      </div>
 <div className='intro_img'>
 <div style={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
        {/* <div className="num animate-value"  data-end="100">0</div><a style={{fontSize:'30px',paddingLeft:'0px'}}>+</a> */}
        </div>
        <div className="text">Passionate</div>
      </div>
            </div>
         </div>
        
         <div className='hero__right'  >
         <div>
        <div className='rightbox_paragraph_up'>
     About Us
            </div>
            <a>-Intell<img src={e} className='elogo' />Sphere</a>
            </div>
           
      <div className='rightbox_paragraph'>
    <br></br>
At IntelleSphere, we are a trusted name in the 
IT staffing industry, known for our commitment to excellence 
and precision in talent acquisition. Backed by a leadership 
team with over two decades of experience in IT and staffing, 
we specialize in connecting leading enterprises and top-tier 
tech companies with the talent they need to stay competitive. 
Our client-centric approach and deep domain expertise allow us 
to deliver customized hiring solutions that align with both immediate and long-term business goals.
 </div>
           
           
         </div>
      
      </div>
    </section>

    <div className='section3_d'>
    {/* <a>WHAT WE DO</a>
            <h1>Services at Tekcog</h1> */}
           <div className='sevices_in_t'>
            <div className='sevices_box_t animate'>
       
            <h1>Mission</h1>
           
            <p>To connect exceptional talent with forward-thinking 
              companies by delivering tailored staffing solutions that drive 
              business success and empower careers. We are committed to integrity, speed, 
              and precision in every hire.</p>
        
            </div>
            
            <div className='sevices_box_t animate'>
            <img
            // src={devops}
            className='animeImg'
            
            />
            <h1>Vision</h1>
           
            <p>To be the most trusted partner in workforce solutions, 
              redefining the future of staffing through innovation, inclusivity, and unparalleled 
              client and candidate experiences.</p>
        
            </div>
       
     
            {/* <img
            src={Tlogo}
            className='imageSide'
            
            /> */}
           </div>
           <div className='sevices_in2_a '>
         
 

         <div className='sevices_box2_t animate'>
         <img
         // src={s}
         className='animeImg'
         
         />
         <a>Empowering Innovation Through Precision Talent Sourcing</a>
        
         <p>Our strength lies in our ability to source and deliver niche talent across a wide range of technologies. From Java Full Stack Development, Python Engineering, and Salesforce, to advanced roles in Machine Learning, Artificial Intelligence, and Cybersecurity, we maintain a dynamic pool of skilled professionals. Importantly, we do not limit ourselves to these tech stacks — our agile recruitment model enables us to fulfill talent needs across a broad and evolving spectrum of technologies, frameworks, and platforms, based on each client’s unique requirements.
 Whether you're a fast-scaling startup or an enterprise undergoing digital transformation, IntelleSphere ensures the right talent meets the right opportunity. We don’t just fill roles - we build high-performance teams equipped to drive innovation and growth. Our mission is clear and impactful: Connecting Great Talent with the Perfect Opportunity. Partner with us and hire with confidence.</p>
     
         </div>
     
        
         {/* <img
         src={Tlogo}
         className='imageSide'
         
         /> */}
        </div>
          
    </div>
 
          
    </div>
    
    
  )
}






